import { hasValue } from 'common/validations/field';
import defaultClientFormValidations from 'common/validations/form/defaultClient';
import i18n from 'i18n';

const validateCreateClientForm = (values) => {
  const errors = defaultClientFormValidations(values);

  if (!hasValue(values.password)) {
    errors.password = i18n.t('emptyField', { ns: 'validations' });
  }

  return errors;
};

export default validateCreateClientForm;
